/** Normalise user input (URL or hostname) to stored project domain. */
export function normalizeWebsiteToDomain(raw: string): string | null {
  const t = raw.trim();
  if (!t) return null;
  try {
    const withProto = /^https?:\/\//i.test(t) ? t : `https://${t}`;
    const u = new URL(withProto);
    const host = u.hostname.toLowerCase();
    return host || null;
  } catch {
    const stripped = t
      .replace(/^https?:\/\//i, '')
      .split(/[/?#]/)[0]
      ?.trim()
      .toLowerCase();
    return stripped || null;
  }
}

export function websiteHref(domain: string | null | undefined): string | null {
  if (!domain?.trim()) return null;
  const d = domain.trim();
  if (/^https?:\/\//i.test(d)) return d;
  return `https://${d}`;
}

export function websiteLabel(domain: string | null | undefined): string {
  if (!domain?.trim()) return '—';
  return domain.replace(/^https?:\/\//i, '').replace(/\/$/, '');
}
